/**
 * Build-time theme selection via the `VITE_THEME` env var (set when building the
 * web bundle). Default keeps the original brand (teal/navy palette + the
 * "AI Marketing." text wordmark). `VITE_THEME=dibrework` enables the dibrework
 * branding: gold + warm-dark palette, the cup logo, and the "Marketech" name.
 *
 * The colour swap lives in tailwind.config.ts (reads process.env.VITE_THEME);
 * the logo/name swap is driven by the constants below + the <Brandmark> component.
 */
export const THEME = import.meta.env.VITE_THEME ?? "default";

export const IS_DIBREWORK = THEME === "dibrework";
export const IS_KESIA = THEME === "kesia";

/** App display name (browser title, login). */
export const APP_NAME = IS_DIBREWORK
  ? "Marketech"
  : IS_KESIA
    ? "Kesia Marketing"
    : "AI Marketing Specialist";
